import { getBannerInfo } from "../pages/bannerInfo";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebaseConfig";

/**
 * Generates a multi-page PDF of appointment details using jsPDF-AutoTable,
 * with no overflow and tighter row spacing.
 * Also loads coachComps and schoolComps from the clients collection.
 */
export const generateAppointmentPDF = async (appointment) => {
  if (!appointment) {
    alert("No appointment selected!");
    return;
  }

  let coachComps = "";
let schoolComps = "";

if (appointment.clientID) {
  try {
    console.log("Looking up client by clientID field:", appointment.clientID);

    const q = query(
      collection(db, "clients"),
      where("clientID", "==", appointment.clientID)
    );

    const querySnapshot = await getDocs(q);

    if (!querySnapshot.empty) {
      const clientData = querySnapshot.docs[0].data();
      console.log("Client data loaded for PDF:", clientData);

      coachComps = clientData.coachComps || "";
      schoolComps = clientData.schoolComps || "";
    } else {
      console.warn("No client found with clientID field:", appointment.clientID);
    }
  } catch (error) {
    console.error("Error fetching client comp fields:", error);
  }
}

  const docPdf = new jsPDF();

  // ——— Title ———
  docPdf.setFont("helvetica", "bold");
  docPdf.setFontSize(18);
  docPdf.text("Appointment Details", 14, 20);

  // ——— Helpers ———
  const formatDate = (isoDate) => {
    if (!isoDate) return "";
    const d = new Date(isoDate);
    return d.toLocaleDateString("en-US", {
      weekday: "long",
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
  };

  const formatTime = (dtStr) => {
    if (!dtStr) return "";
    const d = new Date(dtStr);
    return d.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  // ——— Build rows ———
  const rows = [
    ["Client", appointment.client || ""],
    ["Client ID", appointment.clientID || ""],
    ["Date", formatDate(appointment.appointmentDate)],
    ["Start Time", formatTime(appointment.start)],
    ["End Time", formatTime(appointment.end)],
    [
      "Photographers",
      Array.isArray(appointment.photographers)
        ? appointment.photographers.join(", ")
        : appointment.photographers || "",
    ],
    ["Address", appointment.address || ""],
    ["Summary", appointment.summary || ""],
    ["Bell Notes", appointment.bellNotes || ""],
    ["Field/Building Location", appointment.fieldBuildingLocation || ""],
    ["Appointment Contacts", appointment.appointmentContacts || ""],
    ["Extra Equipment", appointment.extraEquipment || ""],
    ["Order Form Notes", appointment.orderFormNotes || ""],
    ["Banner Info", getBannerInfo(appointment)],
    ["Production Notes", appointment.productionNotes || ""],
    ["Ship To", appointment.alternateShipTo || ""],
    ["Coach Comps", coachComps],
    ["School Comps", schoolComps],
    ["Notes & Schedule", appointment.notes || ""],
  ];

  // ——— Table options ———
  docPdf.autoTable({
    startY: 30,
    head: [["Field", "Details"]],
    body: rows,
    margin: { left: 14, right: 14 },
    styles: {
      font: "helvetica",
      fontSize: 10,
      cellPadding: 2,
      lineHeight: 1,
      overflow: "linebreak",
      cellOverflow: "linebreak",
    },
    headStyles: {
      fillColor: [230, 230, 230],
      textColor: 20,
      fontStyle: "bold",
      cellPadding: 2,
    },
    columnStyles: {
      0: { cellWidth: 50 },
      1: { cellWidth: "auto" },
    },
    tableLineWidth: 0.1,
    tableLineColor: 200,
    theme: "striped",
  });

  // ——— Save PDF ———
  const fileName = `Appointment_${appointment.client || "Details"}.pdf`;
  docPdf.save(fileName);
};